export default __webpack_public_path__ + "images/assets/02e5de3e5ed18134d62001ca978d1f18.svg";